import React from 'react';
import axios from 'axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

const baseUrl = '/api/v1/bookmarks';

const params = page => ({ params: { page } });

export default function useGetBookmarkedWires() {
  const [state, q] = useAxios({
    url: `${baseUrl}/wires`,
    method: 'GET',
    ...params(1),
  }, { manual: true });
  const executeQuery = React.useCallback(page => q(params(page)), [q]);
  return [state, executeQuery];
}
